import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
	selector: 'app-tourism-map-transport',
	templateUrl: './tourism-map-transport.component.html',
	styleUrls: ['./tourism-map-transport.component.css'],
})
export class TourismMapTransportComponent {
	loader = false;
	@Input() vehiclesAll: Array<any> = [];
	@Input() vehicles: Array<any> = [];
	@Input() editable = false;
	@Output() vehiclesChange = new EventEmitter();
	@Output() selected = new EventEmitter();

	constructor() {}

	remove(index) {
		// this.data.splice(index, 1);
	}

	selectRow(item) {
		this.selected.emit(item);
	}

	vehicleChoose(vehicle) {
		vehicle.occupied = 0;
		vehicle.crew = 0;
		this.vehicles.push(vehicle);
		this.vehicleClose();
		this.selectRow(vehicle);
	}

	vehicleOpen() {
		const element = document.getElementById('vehicleModal');
		element.style.display = 'block';
		element.style.paddingRight = '17px';
		element.className = 'modal fade show';
	}

	vehicleClose() {
		const element = document.getElementById('vehicleModal');
		element.style.display = 'none';
		element.className = 'modal fade';
	}
}
